// extracted by mini-css-extract-plugin
export var box = "style-mod--box--b3a67";
export var consentCheckbox = "style-mod--consent-checkbox--66eee";
export var consentContainer = "style-mod--consent-container--b6fcf";
export var emailInput = "style-mod--email-input--09902";
export var field = "style-mod--field--7865a";
export var footerMail = "style-mod--footer-mail--7f0db";
export var successMsg = "style-mod--success-msg--3acf2";
export var text = "style-mod--text--2c5aa";